import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const PostgreSQLIntegration = React.lazy(() => import("./PostgreSQLIntegration"));

interface PostgreSQLIntegrationLazyProps {
  isOpen: boolean;
  onClose: () => void;
  onRefetch?: () => void;
  brandTheme?: string | null;
}

export default function PostgreSQLIntegrationLazy(props: PostgreSQLIntegrationLazyProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <PostgreSQLIntegration {...props} />
    </Suspense>
  );
}
